import { useContext } from 'react';
import AppContext from '../../../AppContext';
import TextFormat from '../../format/TextFormat';
import AnnualChangeRowData from './AnnualChangeRowData';
import { renderYearValueAsText } from './yearRenderUtils';

export default function TextRow({
  currentYear,
  priorYear,
  priorYearMinusOne,
  priorYearMinusTwo,
  priorYearMinusThree,
  priorYearMinusFour,
  priorYearMinusFive,
  priorYearMinusSix,
  priorYearMinusSeven,
  priorYearMinusEight
}: Readonly<AnnualChangeRowData>) {
  const { activeYearsMode } = useContext(AppContext);
  const showTenYearCells = activeYearsMode === 'TEN' && priorYearMinusFour !== undefined;
  return (
    <>
      <p></p>
      <p></p>
      <p></p>
      <p></p>
      <p></p>
      {renderYearValueAsText(currentYear)}
      {renderYearValueAsText(priorYear)}
      {renderYearValueAsText(priorYearMinusOne)}
      {renderYearValueAsText(priorYearMinusTwo)}
      {renderYearValueAsText(priorYearMinusThree)}
      {showTenYearCells && (
        <>
          {renderYearValueAsText(priorYearMinusFour as any)}
          {renderYearValueAsText(priorYearMinusFive as any)}
          {renderYearValueAsText(priorYearMinusSix as any)}
          {renderYearValueAsText(priorYearMinusSeven as any)}
          {renderYearValueAsText(priorYearMinusEight as any)}
        </>
      )}
    </>
  );
}
